module.exports = __webpack_public_path__ + "img/codePic.f2f45709.png";